<template>
  <div class="container-article">
    <div v-for="attribute in errors" :key="attribute.field" class="alert alert-danger">
      {{ attribute.value }}
    </div>
    <h4 class="m-3">Конфигурация</h4>
    <el-form ref="form" label-position="left" label-width="300px">
      <el-form-item label="Основной сервис отправки СМС">
        <el-select v-model="form.primary_sms_service" filterable clearable placeholder="Выберите сервис"
          no-data-text="Нет данных">
          <el-option v-for="service in smsServices" :key="service.value" :label="service.title" :value="service.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Дополнительный сервис отправки СМС">
        <el-select v-model="form.secondary_sms_service" filterable clearable placeholder="Выберите сервис"
          no-data-text="Нет данных">
          <el-option v-for="service in secondarySmsServices" :key="service.value" :label="service.title"
            :value="service.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Версия ios">
        <el-input v-model="form.ios_app_version"></el-input>
      </el-form-item>
      <el-form-item label="Версия Android">
        <el-input v-model="form.android_app_version"></el-input>
      </el-form-item>
      <el-form-item>
        <el-alert type="info" show-icon :closable="false">
          <p>
            Слайдер на главной странице, задержка между переходами
          </p>
        </el-alert>
      </el-form-item>
      <el-form-item label="Задержка(секунды)">
        <el-input type="number" v-model="form.main_slide_time_interval"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onStoreFormData">Сохранить</el-button>
        <el-button @click="back()">Отмена</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
import { SETPRELOADER_STATE } from "@/store/mutation-types";
import Axios from "axios";

export default {
  name: "Config",
  data: function () {
    return {
      smsServices: [
        {
          title: "Express SMS",
          value: 'express_sms',
        },
        {
          title: "МТС",
          value: 'mts',
        },
      ],
      form: {
        primary_sms_service: null,
        secondary_sms_service: null,
        ios_app_version: '',
        android_app_version: '',
        main_slide_time_interval: 0,
      },
      errors: []
    };
  },
  computed: {
    secondarySmsServices() {
      return this.smsServices.filter(s => s.value !== this.form.primary_sms_service)
    }
  },
  mounted() {
    this.$store.commit(SETPRELOADER_STATE, true);

    this.getData()
      .finally(() => this.$store.commit(SETPRELOADER_STATE, false));
  },
  methods: {
    getData() {
      return Axios.get("/config").then(({ data }) => {
        Object.keys(this.form).forEach((prop) => {
          this.form[prop] = data.find(item => item.key === prop)?.value;
        })
      })
    },
    onStoreFormData() {
      const configs = [];
      if (!this.validation()) {
        return;
      }
      Object
        .keys(this.form)
        .forEach(param => configs.push({
          key: param,
          value: this.form[param]
        }));

      axios.post(`config`, {
        configs
      }).then(() => {
        this.$notify.success({
          message: 'Конфигурация сохранена'
        })
      }).catch(() => {
        this.$notify.error({
          message: 'Не удалось сохранить изменения'
        })
      });
    },
    validation() {
      this.errors = [];
      for (const key of Object.keys(this.form)) {
        if (key.includes('app_version')) {
          const validMsg = this.validVersion(this.form[key], key)
          if (validMsg) {
            this.errors.push({ value: validMsg })
          }
        }
      }

      return this.errors.length === 0;
    },
    validVersion(value, key) {
      const template = '0.0.0';
      let result = '';

      if (!value) {
        result = true;
      } else {
        result = value.split('.').length === template.split('.').length;
      }

      const keyName = key === 'ios_app_version' ? 'ios' : 'android';

      return !result ? `Не корректная версия ${keyName}. Пример: 0.0.0 ` : '';
    }
  },
};
</script>

<style></style>
